import api from '../api';

export const CAFETERIA_SECTIONS_REQUEST = 'CAFETERIA_SECTIONS_REQUEST';
export const CAFETERIA_SECTIONS_SUCCESS = 'CAFETERIA_SECTIONS_SUCCESS';
export const CAFETERIA_SECTIONS_FAILURE = 'CAFETERIA_SECTIONS_FAILURE';

const failedCafeteriaSections = payload => ({
  type: CAFETERIA_SECTIONS_FAILURE,
  payload,
});

const receiveCafeteriaSections = payload => ({
  type: CAFETERIA_SECTIONS_SUCCESS,
  payload,
});

const requestCafeteriaSections = () => ({
  type: CAFETERIA_SECTIONS_REQUEST,
});

export const fetchSections = studentId => async (dispatch) => {
  const params = { student_id: studentId };
  dispatch(requestCafeteriaSections());
  try {
    const res = await api('cabinet/cafeteria/sections2', 'get', { params });
    dispatch(receiveCafeteriaSections(res.data));
  } catch (error) {
    dispatch(failedCafeteriaSections({ err: 'Запрос доступности сервисов столовой не удался' }));
  }
};
